module.exports = __webpack_public_path__ + "img/pkulogo_grey.12317b9d.png";